module.exports = __webpack_public_path__ + "static/img/bonus_1.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_1.png
// module id = nOK3
// module chunks = 0